import type { FC } from 'react'
import { MessagesDrawer } from './messages-drawer'
import { useMessagesStore } from '../store'

export const MessagesOverlay: FC = () => {
  const isMessengerOpen = useMessagesStore((s) => s.isMessengerOpen)
  const closeMessenger = useMessagesStore((s) => s.closeMessenger)

  if (!isMessengerOpen) return null

  return (
    <MessagesDrawer onClose={closeMessenger} />
  )
}
